import { trigger, transition, style, animate } from '@angular/animations';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
const _c0 = ["*"];
let NgDocSmoothResizeComponent = /*#__PURE__*/(() => {
  class NgDocSmoothResizeComponent {
    constructor(element) {
      this.element = element;
      this.animateOpacity = true;
      this.resizeAnimation = {
        value: 0,
        params: {
          startHeight: 0,
          startWidth: 0
        }
      };
    }
    ngOnChanges() {
      this.resizeAnimation = {
        value: this.trigger,
        params: {
          startHeight: this.element.nativeElement.clientHeight || 0,
          startWidth: this.element.nativeElement.clientWidth || 0
        }
      };
    }
    static {
      this.ɵfac = function NgDocSmoothResizeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocSmoothResizeComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocSmoothResizeComponent,
        selectors: [["ng-doc-smooth-resize"]],
        hostVars: 1,
        hostBindings: function NgDocSmoothResizeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵsyntheticHostProperty("@resizeAnimation", ctx.resizeAnimation);
          }
        },
        inputs: {
          trigger: "trigger",
          animateOpacity: "animateOpacity"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function NgDocSmoothResizeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:block;overflow:hidden;height:var(--ng-doc-smooth-resize-height);max-height:var(--ng-doc-smooth-resize-max-height)}"],
        data: {
          animation: [trigger('resizeAnimation', [transition('void <=> *', []), transition('* <=> *', [style({
            height: '{{startHeight}}px',
            width: '{{startWidth}}px'
          }), animate('.225s ease-in-out')])])]
        },
        changeDetection: 0
      });
    }
  }
  return NgDocSmoothResizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocSmoothResizeComponent };
